import { useTranslate } from '@im/react-localization';

export const useCountries = () => {
  const translate = useTranslate();

  return [
    { label: translate('Common.CountryCA'), value: 'ca' },
    { label: translate('Common.CountryDE'), value: 'de' },
    { label: translate('Common.CountryIA'), value: 'in' },
    { label: translate('Common.CountryMX'), value: 'mx' },
    { label: translate('Common.CountryUS'), value: 'us' },
    { label: translate('Common.CountryIT'), value: 'it' },
    { label: translate('Common.CountryFR'), value: 'fr' },
    { label: translate('Common.CountryUK'), value: 'uk' },
    { label: translate('Common.CountryES'), value: 'es' },
    { label: translate('Common.CountryIN'), value: 'in' },
    { label: translate('Common.CountryAU'), value: 'au' },
    { label: translate('Common.CountryNZ'), value: 'nz' },
    { label: translate('Common.CountryFI'), value: 'fi' },
    { label: translate('Common.CountrySG'), value: 'sg' },
  ];
};
